// ── Nav ──────────────────────────────────────────────
const nav = document.getElementById('siteNav');
if (nav) {
  const isIndex = document.body.classList.contains('template-index');
  if (!isIndex) {
    // Non-homepage: always solid — never remove it
    nav.classList.add('solid');
  } else {
    // Homepage only: toggle solid on scroll
    window.addEventListener('scroll', () => {
      if (window.scrollY > 50) {
        nav.classList.add('solid');
        nav.classList.remove('dark-nav');
      } else {
        nav.classList.remove('solid');
        nav.classList.add('dark-nav');
      }
    }, { passive: true });
  }
}

// ── Mobile drawer ────────────────────────────────────
const hamburger   = document.getElementById('navHamburger');
const drawer      = document.getElementById('navDrawer');
const drawerClose = document.getElementById('navDrawerClose');
if (hamburger && drawer) {
  hamburger.addEventListener('click', () => {
    drawer.classList.add('open');
    hamburger.setAttribute('aria-expanded', 'true');
  });
  if (drawerClose) {
    drawerClose.addEventListener('click', () => {
      drawer.classList.remove('open');
      hamburger.setAttribute('aria-expanded', 'false');
    });
  }
  drawer.querySelectorAll('a').forEach(a => {
    a.addEventListener('click', () => {
      drawer.classList.remove('open');
      hamburger.setAttribute('aria-expanded', 'false');
    });
  });
}

// ── Scroll reveal ────────────────────────────────────
const io = new IntersectionObserver(entries => {
  entries.forEach(e => {
    if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
  });
}, { threshold: 0.1 });
document.querySelectorAll('.sr').forEach(el => io.observe(el));

// ── Collection filters ───────────────────────────────
document.querySelectorAll('.pill[data-filter]').forEach(btn => {
  btn.addEventListener('click', () => {
    document.querySelectorAll('.pill[data-filter]').forEach(b => b.classList.remove('active'));
    btn.classList.add('active');
    const f = btn.dataset.filter;
    const cards = document.querySelectorAll('.scent-card[data-family]');
    cards.forEach(card => {
      const show = f === 'all' || card.dataset.family === f;
      card.style.transition = 'opacity .3s, transform .3s';
      card.style.opacity    = show ? '1' : '0.2';
      card.style.transform  = show ? '' : 'scale(.97)';
      card.style.pointerEvents = show ? '' : 'none';
    });
    const visible = f === 'all' ? cards.length : document.querySelectorAll(`.scent-card[data-family="${f}"]`).length;
    const countEl = document.querySelector('.filter-count');
    if (countEl) countEl.textContent = `${visible} fragrance${visible !== 1 ? 's' : ''}`;
  });
});

// ── Newsletter (Shopify form already handles server-side) ─
// Client-side validation only
document.querySelectorAll('#newsletter-form').forEach(form => {
  form.addEventListener('submit', e => {
    const input = form.querySelector('input[type=email]');
    if (!input || !input.value) { e.preventDefault(); input.focus(); }
  });
});

// ── Cart Drawer ──────────────────────────────────────
function _cartMoney(cents) {
return '€' + (cents / 100).toFixed(2).replace('.', ',');}

function _padCount(n) {
  return String(n).padStart(2, '0') + ' ' + (n === 1 ? 'Item' : 'Items');
}

function _updateNavCount(n) {
  document.querySelectorAll('.cart-count').forEach(el => {
    el.textContent = n;
    el.style.display = n > 0 ? '' : 'none';
  });
}

function _renderDrawer(cart) {
  const countEl   = document.getElementById('drawerCount');
  const bodyEl    = document.getElementById('drawerBody');
  const footerEl  = document.getElementById('drawerFooter');
  const totalEl   = document.getElementById('drawerSubtotal');
  if (!bodyEl) return;

  if (countEl) countEl.textContent = _padCount(cart.item_count);
  _updateNavCount(cart.item_count);

  if (cart.item_count === 0) {
    bodyEl.innerHTML = '<div class="cart-drawer__empty">Your bag is empty</div>';
    if (footerEl) footerEl.style.display = 'none';
    return;
  }

  bodyEl.innerHTML = cart.items.map(item => {
    const imgUrl = (item.featured_image && item.featured_image.url)
      ? item.featured_image.url + '&width=160'
      : (item.image ? item.image + '&width=160' : '');
    const variantLine = item.variant_title && item.variant_title !== 'Default Title'
      ? `<div class="cart-item__variant">${item.variant_title}</div>` : '';
    return `<div class="cart-item" data-key="${item.key}">
      ${imgUrl ? `<img class="cart-item__img" src="${imgUrl}" alt="${item.title}" loading="lazy">` : '<div class="cart-item__img"></div>'}
      <div class="cart-item__info">
        <div class="cart-item__title">${item.product_title}</div>
        ${variantLine}
        <div class="cart-item__price">${_cartMoney(item.price)}</div>
        <div class="cart-item__controls">
          <button class="cart-item__qty-btn" data-action="decrease" data-key="${item.key}" aria-label="Decrease">−</button>
          <span class="cart-item__qty">${item.quantity}</span>
          <button class="cart-item__qty-btn" data-action="increase" data-key="${item.key}" aria-label="Increase">+</button>
          <button class="cart-item__remove" data-key="${item.key}" aria-label="Remove">Remove</button>
        </div>
      </div>
    </div>`;
  }).join('');

  if (footerEl) {
    footerEl.style.display = '';
    if (totalEl) totalEl.textContent = _cartMoney(cart.total_price);
  }
}

async function openCartDrawer() {
  const panel   = document.getElementById('cartDrawer');
  const overlay = document.getElementById('cartOverlay');
  if (!panel) return;
  try {
    const cart = await (await fetch('/cart.js')).json();
    _renderDrawer(cart);
  } catch (_) {}
  panel.classList.add('open');
  overlay && overlay.classList.add('open');
  panel.setAttribute('aria-hidden', 'false');
  document.body.style.overflow = 'hidden';
}

function closeCartDrawer() {
  const panel   = document.getElementById('cartDrawer');
  const overlay = document.getElementById('cartOverlay');
  panel && panel.classList.remove('open');
  overlay && overlay.classList.remove('open');
  panel && panel.setAttribute('aria-hidden', 'true');
  document.body.style.overflow = '';
}

window.openCartDrawer  = openCartDrawer;
window.closeCartDrawer = closeCartDrawer;

document.addEventListener('DOMContentLoaded', () => {
  document.getElementById('cartDrawerClose')
    ?.addEventListener('click', closeCartDrawer);

  document.getElementById('cartOverlay')
    ?.addEventListener('click', closeCartDrawer);

  document.addEventListener('keydown', e => {
    if (e.key === 'Escape') closeCartDrawer();
  });

  document.getElementById('drawerBody')
    ?.addEventListener('click', async e => {
      const btn = e.target.closest('[data-action], .cart-item__remove');
      if (!btn) return;
      const key  = btn.dataset.key;
      const item = btn.closest('.cart-item');
      const qtyEl = item?.querySelector('.cart-item__qty');
      let qty = parseInt(qtyEl?.textContent || '1');
      if (btn.dataset.action === 'increase') qty++;
      else if (btn.dataset.action === 'decrease') qty = Math.max(0, qty - 1);
      else qty = 0;
      try {
        const res  = await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: key, quantity: qty })
        });
        const cart = await res.json();
        _renderDrawer(cart);
      } catch (_) {}
    });

  document.querySelectorAll('[data-cart-trigger]').forEach(el => {
    el.addEventListener('click', e => { e.preventDefault(); openCartDrawer(); });
  });
});
